export default "__VITE_ASSET__39110944__"